import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({ id: 'setup.traffic.timeWindows.editAction' }),
    cancel: translate({ id: 'global.cancel' }),
    save: translate({ id: 'global.save' }),
    invalidTimeWindow: translate({ id: 'setup.traffic.timeWindow.startEndError' }),
    overlappingTimeWindow: translate({ id: 'setup.traffic.timeWindows.validation.overlapping' }),
  }))

  return api
}
